class TooltipRegistry
{
    static registryInstance = null;

    constructor()
    {
        if ( !TooltipRegistry.registryInstance )
        {
            this.contents = {};
            TooltipRegistry.registryInstance = this;
        }
    }

    static instance()
    {
        if (TooltipRegistry.registryInstance)
        {
            return TooltipRegistry.registryInstance; 
        }
        return new TooltipRegistry();
    }

    getContentObject( contentId )
    {
        if ( !this.contents[contentId] )
        {
            this.contents[contentId] = { 
                contentId,  content: ""
            }
        }
        return this.contents[contentId];
    }

    setContent( contentId, content )
    {
        this.getContentObject( contentId ).content = content;
    }

}
export default TooltipRegistry;
